import { IRecentlyUsedMediaState } from 'store/types/recentlyUsedMedia'

export const getInitialState = (): IRecentlyUsedMediaState => ({
  externalMediaItems: []
})
